import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserRestrictionsService } from '../../services/user/user-restrictions.service';
import { ModalService } from '../../modal/modal.service';
import { filter, switchMap } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { UserService } from '../../services/user/user.service';
import { PlatformService } from 'ngx-unificator/services';

export const RestrictionsGuard: CanActivateFn = (route, state) => {
  const restrictions = inject(UserRestrictionsService);
  const modal = inject(ModalService);
  const router = inject(Router);
  const user = inject(UserService);
  const platform = inject(PlatformService);

  if (!platform.isBrowser) {
    return true;
  }

  if (user.auth !== undefined && user.auth === false) {
    return true;
  }

  return restrictions.isResolvePlayerRestrictions$.pipe(
    filter(isResolved => isResolved),
    switchMap(() => {
      if (restrictions.isBetAccountLock()) {
        router.navigateByUrl('/');
        return from(
          import('../../modal/components/lazy/bet-block/bet-block.component').then(component => {
            modal.openLazy(component.BetBlockComponent, {
              template: 'CLEAR',
              closeAfterRouteChange: false,
            });
            return false;
          }),
        );
      }

      return of(true);
    }),
  );
};
